module.exports = __webpack_public_path__ + "img/zhekouquan_bg3.307436ec.png";